import React, { useEffect, useState } from 'react';
import { Tab, Tabs } from '@mui/material';
import { AdminTabsWrapper, AdminTabPanel } from './AdminTabs.styled';
import AdminBalance from '../AdminBalance/AdminBalance';
import AdminBookings from '../AdminBookings/AdminBookings';
import AdminPanel from '../AdminPanel';
import EmojiObjectsOutlinedIcon from '@mui/icons-material/EmojiObjectsOutlined';
import BookmarkAddedOutlinedIcon from '@mui/icons-material/BookmarkAddedOutlined';
import CurrencyRubleOutlinedIcon from '@mui/icons-material/CurrencyRubleOutlined';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AdminTrainings from '../AdminTrainings/AdminTrainings';
import { IPlace } from '@/components/Dto';
import { useHookState } from '../../NotificationApiHook';
import { fetchPlaceData } from '../../api';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ru from 'date-fns/locale/ru';

const AdminTabs = () => {
  const { notificationState } = useHookState();

  const [tabValue, setTabValue] = useState(0);
  const [placesOptions, setPlacesOptions] = useState<IPlace[]>([]);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    fetchPlaceData(notificationState)
      .then((data) => {
        setPlacesOptions(
          data?.map((place: IPlace) => ({ ...place, value: place.id, label: place.name })),
        );
      })
      .catch((err) => console.error('Error fetching place data:', err));
  }, []);

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={ru}
    >
      <AdminTabsWrapper>
        <Tabs
          value={tabValue}
          onChange={handleChange}
          variant='fullWidth'
        >
          <Tab
            label='Свет'
            icon={<EmojiObjectsOutlinedIcon />}
            iconPosition='top'
          />
          <Tab
            label='Брони'
            icon={<BookmarkAddedOutlinedIcon />}
            iconPosition='top'
          />
          <Tab
            label='Баланс'
            icon={<CurrencyRubleOutlinedIcon />}
            iconPosition='top'
          />

          <Tab
            label='Тренировки'
            icon={<CalendarMonthIcon />}
            iconPosition='top'
          />
        </Tabs>

        <AdminTabPanel
          value={tabValue}
          index={0}
        >
          <AdminPanel />
        </AdminTabPanel>

        <AdminTabPanel
          value={tabValue}
          index={1}
        >
          <AdminBookings placesOptions={placesOptions} />
        </AdminTabPanel>

        <AdminTabPanel
          value={tabValue}
          index={2}
        >
          <AdminBalance />
        </AdminTabPanel>

        <AdminTabPanel
          value={tabValue}
          index={3}
        >
          <AdminTrainings placesOptions={placesOptions} />
        </AdminTabPanel>
      </AdminTabsWrapper>
    </LocalizationProvider>
  );
};

export default AdminTabs;
